import { useEffect } from "react";
import { useRouter } from "next/router";
import useUserStore from "stores/use-user-store";
import type { UserState } from "types/user";

interface UseUserConfig {
  redirect?: string | null;
}

const useUser = (config?: UseUserConfig): UserState => {
  const redirect = config?.redirect || null;

  const router = useRouter();
  const { asPath } = router;

  const { user } = useUserStore();
  useEffect(() => {
    if (!user.isLoggedIn && !user.loading && redirect) {
      const queryParams = redirect.includes("signin")
        ? `?${new URLSearchParams({ redirect: asPath })}`
        : "";

      router.push(`${redirect}${queryParams}`);
    }
  }, [user, redirect, router, asPath]);

  return user;
};

export default useUser;
